import {WebSocketOperationButton} from "../../../components/web-socket/WebSocketOperationButton";
import React, {useCallback} from "react";
import {SeatingPlan} from "../../../api/Model";
import {AppPages, usePageUrl} from "../../../app-layout/AppPages";
import {useNavigate} from "react-router-dom";
import {useNeighbourhoodStore} from "../../../api/NeighbourhoodStore";
import {useSeatingPlanStore} from "../../../api/SeatingPlanStore";
import ApprovalIcon from "@mui/icons-material/Approval";
import {SeatingPlanModel} from "../SeatingPlanModel";
import {PageAction} from "../../../components/page-action/PageActionHandler";
import {useCurrentOfficeStore} from "../../../api/CurrentOfficeStore";
import {usePermission} from "../../../util/access/UseAccess";
import {Neighbourhoods_Admin, SeatingPlans_Execute} from "../../../util/access/Permission";

export const applyPlanAction: PageAction<SeatingPlanModel> = {
    type: 'toolbar-item',
    component: (model: SeatingPlanModel) => (
        <ApplySeatingPlanButton seatingPlan={model.plan}/>
    ),
};

function ApplySeatingPlanButton({seatingPlan}: {
    seatingPlan: SeatingPlan,
}) {
    const currentOfficeId = useCurrentOfficeStore(state => state.officeId);
    const loadNeighbourhoods = useNeighbourhoodStore(state => state.refresh);
    const loadSeatingPlans = useSeatingPlanStore(state => state.refresh);
    const navigate = useNavigate();
    const pageUrl = usePageUrl();
    const {canApply} = usePermission({canApply: [SeatingPlans_Execute, Neighbourhoods_Admin]});

    const handleFinish = useCallback(() => {
        navigate(pageUrl(AppPages.seatingPlanList));
        loadSeatingPlans();
        loadNeighbourhoods();
    }, [navigate, pageUrl, loadSeatingPlans, loadNeighbourhoods])

    return currentOfficeId !== null && canApply ? (
        <WebSocketOperationButton
            endpoint={`/api/operations/offices/${currentOfficeId}/apply-seating-plan/${seatingPlan.id}`}
            description="Save seating plan changes to Envoy"
            actionButtonLabel="Apply Plan"
            icon={<ApprovalIcon/>}
            color="secondary"
            onFinish={handleFinish}
        />
    ) : null;
}
